/** Kort lesbar innsjekkingsreferanse (6 tegn) — tekst-fallback i QR-e-posten. Samme regel som backend `qr_short_ref`. */
export const shortRef = (passengerId: string): string => String(passengerId || '').replace(/-/g, '').slice(-6).toUpperCase();

export const isShortRef = (text: string): boolean => /^[A-Za-z0-9]{6}$/.test(text.trim());

/** Finn passasjeren som matcher en 6-tegns referanse (case-insensitiv). */
export const findByRef = <T extends { id: string }>(items: T[], ref: string): T | undefined => {
  const want = ref.trim().toUpperCase();
  return items.find((it) => shortRef(it.id) === want);
};
